import awsconfig from './aws-exports';
import { oauthRedirectsForHost } from './utils/oauthRedirects';

const oauth = awsconfig.Auth.oauth;
const redirects = oauthRedirectsForHost(
  typeof window === 'undefined' ? undefined : window.location,
  {
    redirectSignIn: oauth.redirectSignIn,
    redirectSignOut: oauth.redirectSignOut
  }
);

const amplifyConfig = {
  ...awsconfig,
  Auth: {
    ...awsconfig.Auth,
    oauth: {
      ...oauth,
      ...redirects
    }
  }
};

export default amplifyConfig;
